/**
 * Glisser-déposer au clavier (ADR-146 addendum (13), accessibilité) : Espace prend l'élément, les flèches
 * choisissent sa place parmi des places nommées en mots, Espace ou Entrée le pose, Échap annule. État pur ;
 * les annonces sont des phrases pour la zone `aria-live`.
 */

export interface KeyboardDrag {
  /** Nom de l'élément pris (« Chasseur », « Texte »). */
  name: string;
  slots: ReadonlyArray<{ label: string }>;
  /** Place choisie ; -1 : aucune encore. */
  index: number;
  /** Place de l'élément lui-même (le parcours commence à côté). */
  start: number;
}

export type KeyboardStep = { state: KeyboardDrag; action: 'move' | 'drop' | 'cancel' | 'none' };

export function startKeyboardDrag(name: string, slots: ReadonlyArray<{ label: string }>, start = 0): KeyboardDrag {
  return { name, slots, index: -1, start: Math.max(0, Math.min(start, slots.length)) };
}

/** Une touche pendant le glisser au clavier. */
export function stepKeyboardDrag(state: KeyboardDrag, key: string): KeyboardStep {
  const count = state.slots.length;
  if (key === 'Escape') return { state, action: 'cancel' };
  if (key === ' ' || key === 'Enter' || key === 'Spacebar') return { state, action: state.index >= 0 ? 'drop' : 'none' };
  const forward = key === 'ArrowDown' || key === 'ArrowRight';
  const backward = key === 'ArrowUp' || key === 'ArrowLeft';
  if ((!forward && !backward) || count === 0) return { state, action: 'none' };
  let index: number;
  if (state.index < 0) index = forward ? Math.min(state.start, count - 1) : Math.max(0, state.start - 1);
  else index = forward ? Math.min(count - 1, state.index + 1) : Math.max(0, state.index - 1);
  return { state: { ...state, index }, action: 'move' };
}

export function pickedAnnouncement(state: KeyboardDrag): string {
  return state.slots.length === 0
    ? `« ${state.name} » ne peut aller nulle part ailleurs. Échap pour annuler.`
    : `« ${state.name} » pris. Flèches pour choisir sa place, Espace pour le poser, Échap pour annuler.`;
}

export function slotAnnouncement(state: KeyboardDrag, refusal: string | null): string {
  const slot = state.slots[state.index];
  if (slot === undefined) return '';
  const where = `${slot.label} (${state.index + 1} sur ${state.slots.length})`;
  return refusal === null ? where : `${where}. Refusé : ${refusal}`;
}
